import { STATUS_TYPE } from '../../../enum';
import { Category } from '../../category/api/interface';
import { Flavor } from '../../flavor/api/interface';
import { Shape } from '../../shape/api/interface';
import { ToppingsCategoryItem } from '../../toppingsCategoryItem/api/interface';

export interface FindCategoryCake {
  limit?: number;
  skip?: number;
  search?: string;
}

export interface GetCategoryCake {
  id: string;
}

export interface CreatePatchCategoryCake {
  id?: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  colorCode: string;
  displayBackgroundColor: string;
  // displayCss: string;
  displayMode: string;
  shapeId: string;
  flavorId: string;
  toppingId: string;
  categoryId: string;
  additionalCategoryIds?: string[];
  position: string;
  isNew: boolean;
  // isSoldOut: boolean;
  activeState: boolean;
  isMostLoved: boolean;
  isBig: boolean;
}

export interface CategoryCake {
  id: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  colorCode: string;
  displayBackgroundColor: string;
  // displayCss: string;
  displayMode: string;
  shapeId: string;
  flavorId: string;
  toppingId: string;
  categoryId: string;
  additionalCategoryIds?: string[];
  additionalCategories?: any[];
  allCategories?: string[];
  categoryCount?: number;
  position: string;
  isNew: boolean;
  // isSoldOut: boolean;
  activeState: boolean;
  isMostLoved: boolean;
  isBig: boolean;
  category: Category;
  flavor: Flavor;
  shape: Shape;
  topping_category_item: ToppingsCategoryItem;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: CategoryCake[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
